"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.themecolor = exports["default"] = void 0;
(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();
var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal["default"].signature : function (a) {
  return a;
};
var themecolor = {
  // shared colors among dark and light
  white: '#FFFFFF',
  grey50: '#F8FAFB',
  grey100: '#EEF2F6',
  grey200: '#E3E8EF',
  grey300: '#CDD5DE',
  grey400: '#A3AEBD',
  grey500: '#758192',
  grey600: '#4D5665',
  grey650: '#364050',
  grey700: '#303845',
  grey800: '#1C212A',
  grey900: '#181A22',
  black: '#000000',
  textDefault: '#333333',
  tabDefault: '#FAFBFD',
  sideNavSelected: '#242C33',
  burntUmber: '#C7904F',
  burntUmberHover: '#D49954',
  burntUmberActive: '#BA874A',
  lightGrey: '#AEB5BC',
  lightGreyHover: '#BBC2C9',
  lightGreyActive: '#A3A9B0',
  lightestGrey: '#E0E4E8',
  lightBlue: '#75D5E2',
  lightBlueHover: '#7CE2F0',
  lightBlueActive: '#6FCAD6',
  lightPurple: '#CD65E7',
  lightPurpleHover: '#D96BF5',
  lightPurpleActive: '#C360DB',
  magenta: '#ba2d92',
  lightBlack: '#1A2732',
  success: '#0ABD63',
  successHover: '#0BC96A',
  successActive: '#09B05C',
  info: '#3FA8F0',
  infoHover: '#42B1FC',
  infoActive: '#3C9FE3',
  warning: '#ECB33D',
  warningHover: '#FABE41',
  warningActive: '#E0AA3A',
  danger: '#F07B7B',
  dangerHover: '#FC8181',
  dangerActive: '#E37474',
  darkGray: '#646F82',
  darkestGray: '#354053',
  disabled: '#AEB5BC',
  blue: '#409AED',
  orange: '#EB722D',
  // Dark Theme colors
  darkPrimary: '#222937',
  darkPrimaryHover: '#2B3345',
  darkPrimaryActive: '#1B202B',
  darkSecondary: '#364050',
  darkSecondaryHover: '#3E495C',
  darkSecondaryActive: '#2D3542',
  darkTextDefault: '#F3F5F8',
  darkTextDefaultHover: '#F7F9FC',
  darkTextDefaultActive: '#E6E8EB',
  // TODO: Implement Light Theme colors
  lightPrimary: '#EDF2F8',
  lightPrimaryHover: '#F4F9FF',
  lightPrimaryActive: '#E0E5EB',
  lightSecondary: '#FFFFFF',
  lightTextDefault: '#1A2632',
  lightTextDefaultHover: '#213040',
  lightTextDefaultActive: '#141D26',
  // Gradients
  greyBlueGradient: 'linear-gradient(to right top, #333333, #484f5d, #4d708a, #3f95b1, #1abccd)',
  berryGradient: 'linear-gradient(-225deg, #622774 0%, #C53364 100%)',
  moonlightGradient: 'linear-gradient(to right, #2C5364, #203A43, #0F2027)',
  greyGradient: 'linear-gradient(0deg, rgba(0, 0, 0, 0.7), rgba(0, 0, 0, 0.7)), #FFFFFF',
  // Analytics Color
  lightSearchGrey: '#F6F7FB',
  grey2: '#E6E4EE',
  searchTitle: '#BEBCC6',
  lightYellow: '#f7ef04',
  // Color Picker
  pickerRed: '#FF0000',
  pickerOrange: '#FF8000',
  pickerYellow: '#FFFF00',
  pickerGreen: '#00FF00',
  pickerCyan: '#00FFFF',
  pickerBlue: '#0000FF',
  pickerMagenta: '#FF00FF',
  pickerPurple: '#7F00FF',
  pickerBrown: '#800000',
  pickerGrey: '#808080'
};
exports.themecolor = themecolor;
var _default = themecolor;
var _default2 = _default;
exports["default"] = _default2;
;
(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;
  if (!reactHotLoader) {
    return;
  }
  reactHotLoader.register(themecolor, "themecolor", "/Users/crs/WebstormProjects/michelangelo/src/Components/styles/color.js");
  reactHotLoader.register(_default, "default", "/Users/crs/WebstormProjects/michelangelo/src/Components/styles/color.js");
})();
;
(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();